export default __webpack_public_path__ + "static/media/huobi-global.494a2a42.svg";